import {Utils} from "./utils";
import {blazyEventSubscribe} from "@/js/src/header-init";

/**
 *
 * @param params
 */
export const landingWithMenu = (params) => {
    const {menu, sectionList} = params;

    if (!menu || !sectionList) {
        return;
    }

    const MENU_HEIGHT = 60;
    const MAX_POS = 1e9;
    const STICKY_CLASS = 'sticky';
    const mainMenu = document.querySelector('#main-menu');
    let boundaries = [];


    init();
    blazyEventSubscribe((element) => {
        if (element.classList.contains('column-img')) {
            init();
        }
    });

    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
    initStickyEvents();

    /**
     * init relative content position
     */
    function init() {
        boundaries = [];

        // init relative content position
        sectionList.forEach((sect, idx) => {
            const pos = Utils.offset(sect).top - (idx > 0 ? MENU_HEIGHT : 0);

            boundaries.push(pos);
        });

        boundaries.push(MAX_POS);
    }

    /**
     * Init sticky menu item click
     */
    function initStickyEvents() {
        menu.querySelectorAll('a').forEach((m, i) => m.addEventListener('click', (e) => {
            window.scrollTo({ top: boundaries[i] + 1 || 0, behavior: 'smooth' });
            e.preventDefault()
        }));
    }

    /**
     * Scroll listener function for sticky menu
     */
    function onScroll() {
        setActiveMenu(window.scrollY);
    }

    /**
     *
     * @param scrollTop
     */
    function setActiveMenu(scrollTop) {
        const diff = boundaries[0] - scrollTop - MENU_HEIGHT + 1;

        mainMenu.style.top = diff < 0 ? diff + 'px' : '0';

        for (let i = 0, len = boundaries.length - 1; i < len; i++) {
            if (scrollTop >= boundaries[i] && scrollTop < boundaries[i + 1]) {
                menu.classList.add(STICKY_CLASS);
                menu.setAttribute('data-active', i);
                return
            }
        }

        menu.setAttribute('data-active', '-1');
        menu.classList.remove(STICKY_CLASS);
    }
}
